// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: 'Inter', sans-serif;
}

.main-content {
  padding: 60px 0 0 0; /* Added top padding equal to navbar height */
  background-color: var(--secondary-color);
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  margin: 0;
}

.App-header {
  background-color: #ffffff;
  padding: 40px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.App-header h1 {
  color: #0047AB;
  font-family: 'Inter', sans-serif;
}

.App-header p {
  color: #333333;
  font-size: 1.2rem;
  font-family: 'Inter', sans-serif;
}

button {
  padding: 12px 24px;
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
  border: none;
  border-radius: 9999px; /* This creates fully rounded corners */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

button:hover {
  transform: translateY(-2px);
}

.primary-button {
  background-color: var(--primary-color);
  color: var(--white);
}

.primary-button:hover {
  background-color: var(--primary-dark);
}

.secondary-button {
  background-color: var(--white);
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}

.secondary-button:hover {
  background-color: var(--primary-color);
  color: var(--white);
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB,EAAE,6CAA6C;EAClE,wCAAwC;EACxC,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,qBAAqB,EAAE,uCAAuC;EAC9D,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n  font-family: 'Inter', sans-serif;\n}\n\n.main-content {\n  padding: 60px 0 0 0; /* Added top padding equal to navbar height */\n  background-color: var(--secondary-color);\n  min-height: 100vh;\n  width: 100%;\n  overflow-x: hidden;\n  margin: 0;\n}\n\n.App-header {\n  background-color: #ffffff;\n  padding: 40px 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.App-header h1 {\n  color: #0047AB;\n  font-family: 'Inter', sans-serif;\n}\n\n.App-header p {\n  color: #333333;\n  font-size: 1.2rem;\n  font-family: 'Inter', sans-serif;\n}\n\nbutton {\n  padding: 12px 24px;\n  font-size: 1rem;\n  font-family: 'Inter', sans-serif;\n  border: none;\n  border-radius: 9999px; /* This creates fully rounded corners */\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\nbutton:hover {\n  transform: translateY(-2px);\n}\n\n.primary-button {\n  background-color: var(--primary-color);\n  color: var(--white);\n}\n\n.primary-button:hover {\n  background-color: var(--primary-dark);\n}\n\n.secondary-button {\n  background-color: var(--white);\n  color: var(--primary-color);\n  border: 2px solid var(--primary-color);\n}\n\n.secondary-button:hover {\n  background-color: var(--primary-color);\n  color: var(--white);\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
